import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Radio({ checked, disabled, name, value, onChange, children }) {
    return (_jsxs("label", { className: "radio", disabled: disabled, children: [_jsx("input", { type: "radio", disabled, checked, name, value, onChange }), " ", children] }));
}
//# sourceMappingURL=Radio.js.map